import React, {lazy} from 'react';
import {RoutePermittedRole} from '@crema/constants/AppEnums';

const PendingBusinesses = lazy(
  () => import('../../../modules/businesses/PendingBusinesses'),
);
const RejectedBusinesses = lazy(
  () => import('../../../modules/businesses/RejectedBusinesses'),
);
const AllBusinesses = lazy(
  () => import('../../../modules/businesses/AllBusinesses'),
);
const BusinessDetail = lazy(
  () => import('../../../modules/businesses/BusinessDetail'),
);
const AllCategories = lazy(
  () => import('../../../modules/categories/AllCategories'),
);
const AllBookings = lazy(() => import('../../../modules/bookings/AllBookings'));
const BookingDetail = lazy(
  () => import('../../../modules/bookings/BookingDetail'),
);
const AllPayments = lazy(() => import('../../../modules/payments/AllPayments'));
const PaymentDetail = lazy(
  () => import('../../../modules/payments/PaymentDetail'),
);
const Settings = lazy(() => import('../../../modules/settings'));
const AllSubscriptions = lazy(
  () => import('../../../modules/subscriptions/AllSubscriptions'),
);
const SendNotification = lazy(
  () => import('../../../modules/notifications/SendNotification'),
);
const AllUsers = lazy(() => import('../../../modules/users/AllUsers'));
const AllServices = lazy(() => import('../../../modules/services/AllServices'));

export const dashBoardConfigs = [
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/businesses/all',
    element: <AllBusinesses />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/businesses/:id',
    element: <BusinessDetail />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/businesses/pending',
    element: <PendingBusinesses />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/businesses/rejected',
    element: <RejectedBusinesses />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/categories',
    element: <AllCategories />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/services',
    element: <AllServices />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/bookings',
    element: <AllBookings />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/bookings/:id',
    element: <BookingDetail />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/payments',
    element: <AllPayments />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/payments/:id',
    element: <PaymentDetail />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/subscriptions',
    element: <AllSubscriptions />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/notifications/send',
    element: <SendNotification />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/users',
    element: <AllUsers />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/settings',
    element: <Settings />,
  },
];
